'use client'

import { Button } from '../../buttons'
import { FormField } from '../../form-field'
import { Stack } from '../../stack'
import { Modal, type ModalProps } from '../modal.tsx'

type FieldModalProps = ModalProps &
  Readonly<{
    open: boolean
    title: string
    label?: string
    t: (key: 'save-and-close' | 'cancel' | 'close') => string
    onSave?: () => void
    readonly?: boolean
  }>

const FieldModal = ({
  title,
  label,
  onSave,
  onClose,
  readonly,
  children,
  t,
  ...props
}: FieldModalProps) => {
  return (
    <Modal {...{ ...props, onClose }}>
      <Stack direction="col" width="5/12" height="full">
        <Modal.Overline>
          <Modal.Heading>{title}</Modal.Heading>
        </Modal.Overline>
        <Modal.Surface width="full" height="full">
          <Modal.Surface.Body size="full">
            <FormField width="full">
              {label && <FormField.Label>{label}</FormField.Label>}
              {children}
            </FormField>
          </Modal.Surface.Body>
          <Modal.Surface.Footer>
            {!readonly && (
              <Button onClick={onSave} width="full" className="mb-2">
                {t('save-and-close')}
              </Button>
            )}
            <Button variant={'secondary'} onClick={onClose} width="full">
              {t(readonly ? 'close' : 'cancel')}
            </Button>
          </Modal.Surface.Footer>
        </Modal.Surface>
      </Stack>
    </Modal>
  )
}

export { FieldModal, type FieldModalProps }
